import { SOCKET_EVENT_NAMES } from '@/shared/socket/types';
import type {
  SocketEventEnvelope,
  SocketEventName,
  SocketPayloadContext,
} from '@/shared/socket/types';

const EVENT_SET = new Set<string>(SOCKET_EVENT_NAMES);

function asEventName(value: unknown): SocketEventName | null {
  if (typeof value !== 'string') {
    return null;
  }

  return EVENT_SET.has(value) ? (value as SocketEventName) : null;
}

export function extractSocketEventFromBody(
  body: unknown,
): SocketEventName | null {
  if (!body || typeof body !== 'object') {
    return null;
  }

  const envelope = body as SocketEventEnvelope;

  return asEventName(
    envelope.event ??
      envelope.eventName ??
      envelope.type ??
      (envelope as { updateType?: unknown }).updateType,
  );
}

export function extractSocketPayloadContext(
  parsedBody: unknown,
): SocketPayloadContext {
  if (!parsedBody || typeof parsedBody !== 'object') {
    return {};
  }

  const root = parsedBody as Record<string, unknown>;
  const bookingDTO = (root.bookingDTO ?? {}) as Record<string, unknown>;
  const tableDTO = (root.tableDTO ?? {}) as Record<string, unknown>;
  const roomDTO = (root.roomDTO ?? {}) as Record<string, unknown>;

  return {
    branchCode:
      (root.branchCode as string | undefined) ??
      (bookingDTO.branchCode as string | undefined) ??
      (tableDTO.branchCode as string | undefined) ??
      (roomDTO.branchCode as string | undefined),
    bookingCode:
      (bookingDTO.bookingCode as string | undefined) ??
      (root.bookingCode as string | undefined),
    bookingDate:
      (bookingDTO.bookingDate as string | undefined) ??
      (root.bookingDate as string | undefined),
    bookingDateAfterUpdate:
      (bookingDTO.bookingDateAfterUpdate as string | undefined) ??
      (root.bookingDateAfterUpdate as string | undefined),
    updateType: (root.updateType as string | undefined) ?? undefined,
    roomCode:
      (roomDTO.roomCode as string | undefined) ??
      (tableDTO.roomCode as string | undefined) ??
      (root.roomCode as string | undefined),
    tableCode:
      (root.tableCode as string | undefined) ??
      (tableDTO.tableCode as string | undefined),
  };
}
